// src/components/WallConstants.ts
import japanCard from '../../placeholders/images/japan_card.png';
import newspaperCard from '../../placeholders/images/newspaper_card.png';
import nikeCard from '../../placeholders/images/nike_card.png';
import zooCard from '../../placeholders/images/zoo_card.png';
import gazaCard from '../../placeholders/images/gaza_card.png';
import dinnerCard from '../../placeholders/images/dinner_card.png';
import veniceCard from '../../placeholders/images/venice_card.png';
import interCard from '../../placeholders/images/inter_card.png';
import architectureCard from '../../placeholders/images/architecture_card.png';
import heidiCard from '../../placeholders/images/heidi_card.png';
import dragonballCard from '../../placeholders/images/dragonball_card.png';
import snowboardCard from '../../placeholders/images/snowboard_card.png';
import teslaCard from '../../placeholders/images/tesla_card.png';
import spaceCard from '../../placeholders/images/space_card.png';
import aiCard from '../../placeholders/images/ai_card.png';
import psychologyCard from '../../placeholders/images/psychology_card.png';
import climateCard from '../../placeholders/images/climate_card.png';
import startupCard from '../../placeholders/images/startup_card.png';
import historyCard from '../../placeholders/images/history_card.png';
import truecrimeCard from '../../placeholders/images/truecrime_card.png';
import healthCard from '../../placeholders/images/health_card.png';
import deepseaCard from '../../placeholders/images/deepsea_card.png';
import fitnessCard from '../../placeholders/images/fitness_card.png';
import bookCard from '../../placeholders/images/book_card.png';

export type BackgroundCardItem = {
  id: string;
  imageUrl: string;
  likes: number;
  publishedBy: string;
  title?: string;
};

// Local image imports - 24 total cards
const LOCAL_IMAGE_PATHS = [
  japanCard,
  newspaperCard,
  nikeCard,
  zooCard,
  gazaCard,
  dinnerCard,
  veniceCard,
  interCard,
  architectureCard,
  heidiCard,
  dragonballCard,
  snowboardCard,
  teslaCard,
  spaceCard,
  aiCard,
  psychologyCard,
  climateCard,
  startupCard,
  historyCard,
  truecrimeCard,
  healthCard,
  deepseaCard,
  fitnessCard,
  bookCard,
];

const LIKES: number[] = [
  24, 31, 45, 52, 18, 67, 29, 73, 56, 41, 
  13, 42, 88, 69, 42, 36, 77, 34, 58, 49, 
  81, 26, 69, 53
];

const USER_HANDLES: string[] = [
  'adventuresgirl', 'fundo01', 'themaclife', 'busi', 
  'newsglobal', 'cgusteau', 'gianscala', 'forzainter', 'zansky', 
  'heidijourney', 'animeworld', 
  'jack42', 'techpioneer', 'spaceexplorer',
  'aifuturist', 'mindmaster', 'climatewarrior',
  'startupfounder', 'historybuff', 'truecrimeexpert', 'healthguru', 
  'daveocean','fitnesstrainer', 'ahonnold'
];

const TITLES: string[] = [
  'Osaka Unleashed: 7 Days of Food and Culture',
  'Trade Wars Decoded: US-China Economic Battle',
  'Just Do It: Inside Nike Global Empire',
  'From Streets to Stardom: A Rapper Rise',
  'Gaza Conflict: The Horrors of the Ceasefire War',
  'Culinary Secrets: 5-Star Dinner Masterclass',
  'Venetian Dreams: Lost in Canals and Culture',
  'Serie A Glory: Finals That Made History',
  'Architectural Wonders: Dream Home Blueprint',
  'Heidi Journey Through Switzerland',
  'Vegeta vs Frieza: The Dragon Ball Saga That Changed Anime',
  'Alpine Thrills: Conquering the Swiss Alps',
  'Tech Titans: Inside Silicon Valley Revolution',
  'Space Odyssey: The Future of Interstellar Travel',
  'AI Revolution: How Robots are Changing Everything',
  'Mind Games: The Psychology of Peak Performance',
  'Climate Crisis: Solutions for a Sustainable Future',
  'Startup Secrets: Building a Billion Dollar Company',
  'Ancient Civilizations: Lost Worlds Rediscovered',
  'True Crime Chronicles: The Cases That Shocked the World',
  'Health Revolution: Biohacking Your Way to Longevity',
  'Ocean Mysteries: Journey to the Deep Sea',
  'Fitness Transformation: From Beginner to Athlete',
  'Page Turner: The Book That Changed Everything',
];

export function getBackgroundCards(count: number = 24): BackgroundCardItem[] {
  const n = Math.max(1, Math.min(count, 24));
  return Array.from({ length: n }, (_, i) => {
    const imageIndex = i % LOCAL_IMAGE_PATHS.length;
    const likesIndex = i % LIKES.length;
    const userIndex = i % USER_HANDLES.length;
    const titleIndex = i % TITLES.length;
    
    return {
      id: String(i + 1),
      imageUrl: LOCAL_IMAGE_PATHS[imageIndex],
      likes: LIKES[likesIndex],
      publishedBy: USER_HANDLES[userIndex],
      title: TITLES[titleIndex],
    };
  });
}